var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnInvoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 6h-1.5a.75.75 0 01-.75-.75.75.75 0 01.75-.75h1.5a.749.749 0 01.75.75H18A2.251 2.251 0 0015.75 3V1.5h-1.5V3A2.25 2.25 0 0012 5.25a2.251 2.251 0 002.25 2.25h1.5a.749.749 0 01.75.75.75.75 0 01-.75.75h-1.5a.75.75 0 01-.75-.75H12a2.251 2.251 0 002.25 2.25V12h1.5v-1.5a2.251 2.251 0 002.249-2.25A2.251 2.251 0 0015.75 6zM3 3h3v1.5H3zM3 6h4.5v1.5H3zM3 9h4.5v1.5H3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.5V0H0v15a3 3 0 003 3h9.75a3 3 0 003-3v-1.5zm-9 1.5V1.5H9v12H4.5V15a1.5 1.5 0 01-3 0zm11.25 1.5H5.584A2.968 2.968 0 006 15h8.25a1.5 1.5 0 01-1.5 1.5z"
  }))));
}
export default __webpack_public_path__ + "media/icons/icn_invoice-01cc6f4f.svg";
export { SvgIcnInvoice as ReactComponent };